import { render, staticRenderFns } from "./icon-font.vue?vue&type=template&id=63995497&scoped=true"
import script from "./icon-font.vue?vue&type=script&lang=js"
export * from "./icon-font.vue?vue&type=script&lang=js"
import "./icon-font.vue?vue&type=style&index=0&id=63995497&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63995497",
  null
  
)

export default component.exports